module.exports = __webpack_public_path__ + "img/chevron-right.9e5261a9.svg";